<template>
    <div>
        <v-combobox
            v-model="global_search"
            :search-input.sync="search"
            class="toolbar-input search-transition"
            :filter="v => v && search"
            :style="{ maxWidth: '225px' }"
            :items="results"
            :loading="loading"
            :append-icon="null"
            item-value="name"
            fill-width
            solo
            flat
            hide-details
            hide-no-data
            dense
            color="white"
            return-object
            item-text="name"
            :menu-props="{ 'min-width': 540 }"
            background-color="g2"
            @keydown="onRawSearch"
        >
            <template v-slot:prepend-inner>
                <div class="px-2">
                    <icon icon="Search"/>
                </div>

            </template>
            <template
                slot="label"
            >
                <span class="body-2 font-weight-medium g5--text">{{ $t("Search task/client") }}</span>
            </template>
            <template v-slot:item="{ item }">
                <v-list-item
                    class="menu-list-item"
                    @click.stop="onMenuItemClick(item)"
                >
                    <v-list-item-avatar
                        style="max-width: 28px !important; min-width: 28px !important; width: 28px !important;"
                    >
                        <AccountAvatar
                            v-if="['client', 'account'].includes(item.type)"
                            text-color="white"
                            text-class="font-weight-medium caption"
                            size="24"
                            :tile="item.type === 'client'"
                            :color="item.avatar ? 'white' : item.color"
                            :image-path="item.avatar"
                            :initials="item.initials"
                            class="mr-0"
                        />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <span class="body-2">{{ item.name }}</span>
                    </v-list-item-content>
                    <v-list-item-action>
                        <span class="text-uppercase body-2">{{ translateResultType(item) }}</span>
                    </v-list-item-action>
                </v-list-item>
            </template>
        </v-combobox>
    </div>
</template>

<script>
import {ref, toRefs, reactive, watch} from "@vue/composition-api";

import {debounce} from "throttle-debounce";
import TaskModule from "../../store/modules/task";
import AccountAvatar from "../../components/AccountAvatar";
import AccountModule from "../../store/modules/account";
import {$t} from "../../i18n";
import TopMenuSearch from "../Dashboard/TopMenuSearch";
import ApiToolbarSearch from '@/api/toolbarSearch/toolbarSearch'

export default {
    name: "AppToolbarSearch",
    components: {
        AccountAvatar
    },
    setup() {
        const {navigateSuggestedEntity} = TopMenuSearch();
        const {current_account} = AccountModule();

        const search = ref("");
        const state = reactive({
            global_search: "",
            results: [],
            loading: false
        });
        const queryAutoSuggest = async keyword => {
            state.loading = true;
            const {results} = await ApiToolbarSearch.search(keyword);
            state.loading = false;
            state.results = results;
        };
        const onSearchInput = debounce(600, function (keyword) {
            queryAutoSuggest(keyword);
        });
        const translateResultType = item => {
            switch (item.type) {
                case "account":
                    if (item.account_id === current_account.value.id) {
                        return $t("Me");
                    }
                    return $t("Account");
                case "client":
                    // code block
                    return $t("Client");
                case "topic":
                    // code block
                    return $t("Topic");
                default:
                    return "";
            }
        };
        const onRawSearch = val => {
            if (val.code === "Enter" && search.value) {
                navigateSuggestedEntity(null, search.value);
                state.global_search = '';
            }
        };
        watch(search, keyword => {
            let old_value = state.global_search ? state.global_search.trim() : '';
            let new_value = keyword ? keyword.trim() : '';
            if (new_value.length === 0) state.results = []
            if (new_value === old_value || new_value.length === 0) return;
            state.global_search = new_value;
            onSearchInput(new_value);
        });

        const onMenuItemClick = item => {
            navigateSuggestedEntity(item);
            state.global_search = '';
        };
        return {
            ...toRefs(state),
            onSearchInput,
            search,
            translateResultType,
            onRawSearch,
            onMenuItemClick
        };
    }
};
</script>

<style scoped>
.search-transition {
    transition-property: transform, width, -webkit-transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.2s;
}
</style>
